import $ from "jquery";
import Swiper from "swiper/bundle";
import videoComponent from "../video/videoComponent";
import CONSTANT from "../../common/js/_constant";

// Pause every video inside every blogstories instance across the page.
// Called whenever a new video starts playing, so only one testimonial
// plays at a time site-wide.
function pauseAllBlogStoryVideos(exceptVideo) {
    $(".blogstories .blogstories-card--video").each(function () {
        if (this !== exceptVideo && !this.paused) {
            this.pause();
            this.currentTime = 0;
        }
    });
}

// Per-instance setup. $section is one `.blogstories` root; every ID and
// Swiper below is scoped to it so multiple instances on the same page
// operate independently.
function initInstance($section) {
    // Identify the instance-scoped modal via the unique id set in HTL
    // (staticBackdrop-<resource.path.hashCode>).
    const $modal = $section.find(".stories-modal");
    const modalId = $modal.attr("id") || "";
    const instanceSelector = "#" + (window.CSS && CSS.escape ? CSS.escape(modalId) : modalId);

    const $cardSwiperEl = $section.find(".blogstories-slider").first();
    const $videoSwiperEl = $section.find(".blogstories-video-slider").first();
    const $cardPaginationEl = $section.find(".stories-pagination").first();
    const $videoPaginationEl = $section.find(".stories-video-pagination").first();

    // Card-row swiper (the grid of thumbnails)
    const cardSwiper = new Swiper($cardSwiperEl.get(0), {
        slidesPerView: 2.2,
        spaceBetween: 16,
        navigation: {
            nextEl: $section.find(".swiper-button-next-stories-main").get(0),
            prevEl: $section.find(".swiper-button-prev-stories-main").get(0),
        },
        pagination: {
            el: $cardPaginationEl.get(0),
            clickable: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 4,
                spaceBetween: 20,
            },
        },
    });
    if (cardSwiper.slides.length <= cardSwiper.params.slidesPerView) {
        $section.find(".swiper-button-next-stories-main").hide();
    }

    // Video swiper (inside the modal)
    const videoSwiper = new Swiper($videoSwiperEl.get(0), {
        slidesPerView: 1,
        loop: true,
        navigation: {
            nextEl: $modal.find(".swiper-button-next-video").get(0),
            prevEl: $modal.find(".swiper-button-prev-video").get(0),
        },
        pagination: {
            el: $videoPaginationEl.get(0),
            clickable: true,
        },
    });
    if (videoSwiper.slides.length <= videoSwiper.params.slidesPerView) {
        $modal.find(".swiper-button-next-video").hide();
    }

    // Register plyr/video controls scoped to this modal
    videoComponent.methods.registerVideo(
        instanceSelector + " .blogstories-card--video",
        { controls: ["play", "progress", "mute"] },
        false
    );

    // Stash state on the section so helpers can retrieve without rebinding
    $section.data("bsInstance", {
        $section: $section,
        $modal: $modal,
        cardSwiper: cardSwiper,
        videoSwiper: videoSwiper,
        cachedAjaxPath: "",
    });
}

// Increment view count for the current slide's content path
function viewIncrement(currentPath) {
    if (!currentPath) {return;}
    $.ajax({
        url: "/bin/chli/views",
        data: { data: currentPath },
        success: function () { /* intentionally silent */ },
    });
}

// Play the active slide's video in the given instance, pausing others
function playActiveVideo(state) {
    const swiperEl = state.videoSwiper;
    const currentSlide = swiperEl.slides[swiperEl.activeIndex];
    if (!currentSlide) {return;}

    const ajaxPath = $(currentSlide).find(".stories-views-holder").data("path");
    const video = $(currentSlide).find("video").get(0);
    if (!video) {return;}

    // Pause everything else first
    pauseAllBlogStoryVideos(video);

    // Move the progress bar into the active bullet (visual handoff)
    const reqBar = $(currentSlide).find(".plyr__progress__container").get(0);
    const $activeBullet = state.$modal
        .find(".stories-video-pagination .swiper-pagination-bullet-active");
    if (reqBar && $activeBullet.length) {
        $activeBullet.append(reqBar);
    }

    video.muted = false;
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(function () { /* autoplay blocked — ignore */ });
    }

    // View increment only fires once per unique path
    if (ajaxPath && state.cachedAjaxPath !== ajaxPath) {
        state.cachedAjaxPath = ajaxPath;
        viewIncrement(ajaxPath);
    }

    // Auto-advance on end (unless we're on the last real slide)
    if (swiperEl.activeIndex < swiperEl.slides.length - 1) {
        video.addEventListener("ended", function onEnded() {
            video.removeEventListener("ended", onEnded);
            swiperEl.slideNext();
        });
    }
}

// Click on a card in the grid: open the modal, advance video swiper to
// the matching index, play that video
function bindCardClicks($section) {
    const state = $section.data("bsInstance");
    $section.find(".blogstories-card").on(CONSTANT.eventsListners.CLICK, function () {
        const targetIndex = Number($(this).data("index"));
        // Wait for the Bootstrap modal to finish opening, then sync the
        // video swiper to the clicked index
        const poll = setInterval(function () {
            if (state.$modal.hasClass("show")) {
                clearInterval(poll);
                // For looped swipers, use slideToLoop if available
                if (typeof state.videoSwiper.slideToLoop === "function") {
                    state.videoSwiper.slideToLoop(targetIndex, 0);
                } else {
                    state.videoSwiper.slideTo(targetIndex, 0);
                }
                playActiveVideo(state);
            }
        }, 100);
    });

    // Pause the active video when modal closes
    state.$modal.on("hidden.bs.modal", function () {
        state.videoSwiper.slides.forEach(function (s) {
            const v = $(s).find("video").get(0);
            if (v) { v.pause(); v.currentTime = 0; }
        });
    });
}

// Handle swiper slide change inside the modal: pause previous video,
// swap next/replay buttons, then play the new slide's video
function bindSlideChange($section) {
    const state = $section.data("bsInstance");
    const $nextBtn = state.$modal.find(".swiper-button-next.next");
    const $replayBtn = state.$modal.find(".swiper-button-next.replay");

    state.videoSwiper.on("slideChange", function () {
        const activeIndex = state.videoSwiper.realIndex;
        const totalSlides = state.videoSwiper.slides.length - 2;

        state.$modal.find(".stories-video-pagination .swiper-pagination-bullet")
            .each(function (index) {
                if (index < activeIndex) {
                    $(this).addClass("custom-opacity");
                } else {
                    $(this).removeClass("custom-opacity");
                }
            });

        if (activeIndex === totalSlides + 1) {
            $nextBtn.addClass("d-none");
            $replayBtn.removeClass("d-none");
        } else {
            $nextBtn.removeClass("d-none");
            $replayBtn.addClass("d-none");
        }

        // Reset the video we just left
        const previousSlide = state.videoSwiper.slides[state.videoSwiper.previousIndex];
        if (previousSlide) {
            const video = $(previousSlide).find("video").get(0);
            if (video) { video.pause(); video.currentTime = 0; }
        }

        // Slight delay lets swiper finish its transition before we play
        setTimeout(function () { playActiveVideo(state); }, 200);
    });
}

// Datalayer events for the card row's next/prev buttons
function bindDatalayer($section) {
    function dataLayerObj(buttonText, pageSection) {
        const templateMeta = document.querySelector("meta[name='template']");
        const template = templateMeta ? templateMeta.content : "";
        return {
            articleName: "",
            blogCategory: "",
            blogPageCategory: "",
            buttonText: buttonText || "",
            pageSection: pageSection || "",
            planOption: "",
            pageType: template === "chli-clp-template" ? "Campaign" : "Other page",
            productCategory: document.getElementById("productCategoryName")
                ? document.getElementById("productCategoryName").value : "",
            productName: document.getElementById("productPlanName")
                ? document.getElementById("productPlanName").value : "",
            PageSubCategory: "",
            question: "",
            searchTerm: "",
            videoTitle: "",
            bannerName: "",
            bannerType: "",
            leadForm: "",
        };
    }

    $section.find(".blogstories-slider--operations .swiper-button-prev")
        .on("click", function () {
            if (typeof createDataLayer === "function") {
                createDataLayer("List_Scroll_Previous",
                    dataLayerObj("Previous Button", "Testimonials"));
            }
        });
    $section.find(".blogstories-slider--operations .swiper-button-next")
        .on("click", function () {
            if (typeof createDataLayer === "function") {
                createDataLayer("List_Scroll_Next",
                    dataLayerObj("Next Button", "Testimonials"));
            }
        });
}

$(function () {
    const $sections = $(".blogstories");
    if ($sections.length === 0) {return;}

    $sections.each(function () {
        const $section = $(this);
        initInstance($section);
        bindSlideChange($section);
        bindCardClicks($section);
        bindDatalayer($section);
    });
});
